import React, { useState, useEffect, useRef } from 'react';
import './FormPage.css';
import logo from '../Image/image.png';
import coaching from '../Image/SwimmingCoaching.png';
import playing from '../Image/SwimmingPlaying.png';
import video from '../Image/Testimonial.png';
import badge from '../Image/badge2.png';
import Lottie from "lottie-react";
import successAnimation from "../success.json";
import maleImage from '../Image/male.png'
import femaleImage from '../Image/femle.png';
import { useLocation } from 'react-router-dom';
import 'react-image-crop/dist/ReactCrop.css';
import Swal from 'sweetalert2';
import domtoimage from 'dom-to-image-more';

const testimonials = [
  {
    video: video,
    text: "Whether I'm training for a marathon or just staying active, it helps me push my limits and stay on top of my fitness goals.",
    name: "Prithviraj Singh Hada",
  },
  {
    video: video,
    text: "Whether I'm training for a marathon or just staying active, it helps me push my limits and stay on top of my fitness goals.",
    name: "Prithviraj Singh Hada",
  },
  {
    video: video,
    text: "Whether I'm training for a marathon or just staying active, it helps me push my limits and stay on top of my fitness goals.",
    name: "Prithviraj Singh Hada",
  },
];

const FormPage = () => {
  const [storedName, setStoredName] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [showAnimation, setShowAnimation] = useState(false);
  const [totalUsers, setTotalUsers] = useState(0);
  const [pledgeCount, setPledgeCount] = useState(0);
  const saveUserDataUrl = process.env.REACT_APP_SAVE_USER_DATA;
  const getSummerOf2025Url = process.env.REACT_APP_GET_SUMMER_2025;
  const apiKey = process.env.REACT_APP_API_KEY;
  const [badgeDataUrl, setBadgeDataUrl] = useState(null);
  const location = useLocation();
  const { gender, name } = location.state || {};

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const savedName = userId ? localStorage.getItem(`userName_${userId}`) : localStorage.getItem("userName");
    const savedBadge = userId ? localStorage.getItem(`userBadge_${userId}`) : localStorage.getItem("userBadge");
    const savedGender = userId ? localStorage.getItem(`userGender_${userId}`) : null;

    if (savedName) {
      setStoredName(savedName);
      setSubmitted(true);
    }

    if (savedBadge) {
      setBadgeDataUrl(savedBadge);
    }

    if (savedGender && !gender) {
      // fallback to saved gender if not passed from route
      location.state = { ...location.state, gender: savedGender };
    }
  }, []);


  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const savedName = userId ? localStorage.getItem(`userName_${userId}`) : localStorage.getItem("userName");
    const savedImage = userId ? localStorage.getItem(`userImage_${userId}`) : localStorage.getItem("userImage");
    const savedBadge = localStorage.getItem("userBadge");

    if (savedName) {
      setStoredName(savedName);
      setSubmitted(true);
    }

    if (savedBadge) {
      setBadgeDataUrl(savedBadge);
    }

  }, []);

  const drawBadge = () => {
    const badgeElement = document.querySelector('.badge-container');
    const userId = localStorage.getItem('userId');

    if (!badgeElement || !userId) {
      console.error('Badge container or user ID not found!');
      return;
    }

    document.fonts.ready.then(() => {
      setTimeout(() => {
        domtoimage.toBlob(badgeElement, {
          quality: 1,
          bgcolor: null,
          style: { 'background-color': 'transparent' },
          height: badgeElement.offsetHeight * 2,
          width: badgeElement.offsetWidth * 2,
          style: {
            transform: "scale(2)",
            transformOrigin: "top left",
            width: `${badgeElement.offsetWidth}px`,
            height: `${badgeElement.offsetHeight}px`,
          },
        })

          .then((blob) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              const base64Data = reader.result;

              // Save badge and gender with userId as key
              localStorage.setItem(`userBadge_${userId}`, base64Data);
              localStorage.setItem(`userGender_${userId}`, gender);

              setBadgeDataUrl(base64Data);

              // Trigger download
              const link = document.createElement('a');
              link.href = base64Data;
              link.download = 'Summer2025Badge.png';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            };
            reader.readAsDataURL(blob);
          })
          .catch(console.error);
      }, 500);
    });
  };


  // Update handleShare to use base64 data
  const handleShare = async () => {
    if (!badgeDataUrl) {
      alert("Please generate the badge first.");
      return;
    }

    try {
      // Convert base64 to blob
      const response = await fetch(badgeDataUrl);
      const blob = await response.blob();
      const file = new File([blob], "Summer2025Badge.png", { type: "image/png" });

      // Web Share API (mobile devices)
      if (navigator.share) {
        try {
          await navigator.share({
            files: [file],
            title: "Summer of 2025 Badge",
            text: "Check out my Summer of 2025 Badge! Join the movement!",
          });
          return;
        } catch (shareError) {
          console.log('User canceled share:', shareError);
        }
      }


    } catch (error) {
      console.error('Sharing error:', error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please download the first badge before sharing!",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };





  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(getSummerOf2025Url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch Summer of 2025 data");
        }

        const data = await response.json();
        setTotalUsers(data.TotalUsers);
        setPledgeCount(data.pledgeCount);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    setShowAnimation(true);
  }, []);



  return (
    <div className="form-page">

      <div className="header-section">
        <img src={logo} alt="Machaxi Logo" className="logo" />
        <h2 className='thank-heading'>Thank you for taking the pledge!</h2>

      </div>

      {/* Statistics Section */}
      <div className="statistics-section">
        <p className="stats-number">{pledgeCount}</p>
        <p className="stats-text">Total Pledges Taken</p>
        <div className="line"></div>
        <p className="stats-number">{totalUsers}</p>
        <p className="stats-text">Learnt Swimming with Us</p>
      </div>
      <div className="button-container-slot">
        <a href="https://swimming.playing.machaxi.com/" target="_blank">
          <button className="book-slot">
          Book your free slot now
          </button>
        </a>
      </div>

      {/* Badge Section */}
      <div className="badge-container">
        <div className="header-banner">
          <div className="header-text">Namma Bengaluru</div>
        </div>
        <div className="banner-triangle"></div>

        <div className="circle-frame">
          {gender === 'female' ? (
            <img src={femaleImage} alt="Female Badge" className="UserImage" />
          ) : (
            <img src={maleImage} alt="Male Badge" className="UserImage" />
          )}
          <div className="circle2"></div>
          <div className="circle"></div>
          <div className="circle3">
            <div className='inner-circle'></div>
          </div>
          <div className="group">
            <span className="letter s">S</span>
            <span className="letter u">u</span>
            <span className="letter m1">m</span>
            <span className="letter m2">m</span>
            <span className="letter e">e</span>
            <span className="letter r">r</span>
            <span className="letter space1"> </span>
            <span className="letter o">o</span>
            <span className="letter f">f</span>
            <span className="letter space2"> </span>
            <span className="letter num2">2</span>
            <span className="letter num0">0</span>
            <span className="letter num2_2">2</span>
            <span className="letter num5">5</span>
          </div>
        </div>
      </div>

      <div className="form-section-slot">

        <div className="success-message">
          {showAnimation && !storedName && (
            <div className="animation-overlay">
              <Lottie
                animationData={successAnimation}
                loop={false}
                onComplete={() => setShowAnimation(false)}
              />
            </div>
          )}


          <h2 className='badge-ready'>Your Badge is Ready!</h2>
          <button className="success-button" onClick={drawBadge}>
            Download Badge
          </button>
          <button className="success-button" onClick={handleShare}>
            Share
          </button>
          <div className="line"></div>
        </div>


      </div>

      {/* Explore Plans Section */}
      <div className="explore-section">
        <p className="section-title-thankyou">Explore Our Plans</p>
        <div className="plans">
          <div className="plan">
            <a href="https://swimming.playing.machaxi.com/" target="_blank" rel="noopener noreferrer">
              <img src={playing} alt="Swimming Playing" className="plan-img" />
            </a>
            <p className="explore-text">Swimming Playing</p>
          </div>
          <div className="line2"></div>
          <div className="plan">
            <a href="https://swimming.coaching.machaxi.com/" target="_blank" rel="noopener noreferrer">
              <img src={coaching} alt="Swimming Coaching" className="plan-img" />
            </a>
            <p className="explore-text">Swimming Coaching</p>
          </div>
        </div>
      </div>


      {/* Testimonials Section */}
      {/* <div className="testimonial-section">
        <h2 className="testimonial-title">What our users have to say</h2>
        <div className="testimonial-container">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-video">
                <img src={testimonial.video} alt="Testimonial" />
                <div className="video-overlay">
                  <button className="play-button">
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 24 24"
                      fill="white"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2" fill="transparent" />
                      <polygon points="9,7 9,17 17,12" fill="white" />
                    </svg>
                  </button>
                </div>
              </div>
              <p className="testimonial-para">{testimonial.text}</p>
              <div className="testimonial-name">
                <p className="testimonial-text">{testimonial.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div> */}

    </div>
  );
}

export default FormPage;